var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkComponet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.478,
    height: 94.463,
    viewBox: "0 0 82.478 94.463",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-link-componet",
    transform: "translate(-6.154 -0.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icongraphic",
    d: "M61.471,42.959a5.5,5.5,0,0,0-7.778-7.779l-7.9,7.9a5.508,5.508,0,0,0,0,7.779L41.552,55.1a11.512,11.512,0,0,1,0-16.263l7.9-7.9A11.5,11.5,0,1,1,65.714,47.2L62.86,50.055l-4.242-4.243ZM36.423,52.45l-4.242-4.242-3.108,3.108A11.5,11.5,0,1,0,45.335,67.579l7.9-7.9a11.514,11.514,0,0,0,0-16.263l-4.243,4.242a5.506,5.506,0,0,1,0,7.779l-7.9,7.9a5.5,5.5,0,0,1-7.778-7.778Zm49.709-29.7L47.391.38,39.3,5.061,80.533,28.867V67.134L47.391,86.268,14.251,67.186l-.045-38.3L40.785,13.373l-7.99-4.654L8.645,22.751a5.015,5.015,0,0,0-2.491,4.325V68.923a5.016,5.016,0,0,0,2.5,4.33L44.893,94.175a5.012,5.012,0,0,0,5,0L86.132,73.253a5.013,5.013,0,0,0,2.5-4.33V27.077A5.011,5.011,0,0,0,86.132,22.748Z",
    fill: "#0071b9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkComponet);
export default __webpack_public_path__ + "static/media/link-componet.a9741aec02e02b69673aca372464d824.svg";
export { ForwardRef as ReactComponent };